import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var WaypointIcon = function WaypointIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "WaypointIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5.514 3.287a4.4 4.4 0 0 1 2.485-.778c.883 0 1.748.27 2.486.778a4.6 4.6 0 0 1 1.66 2.086c.342.853.432 1.792.257 2.699a4.7 4.7 0 0 1-1.236 2.385l-2.781 2.867a.54.54 0 0 1-.386.167.54.54 0 0 1-.385-.167l-2.782-2.867a4.7 4.7 0 0 1-1.236-2.385 4.8 4.8 0 0 1 .258-2.699 4.6 4.6 0 0 1 1.66-2.086M7.999 1a5.9 5.9 0 0 0-3.342 1.044A6.13 6.13 0 0 0 2.454 4.81a6.3 6.3 0 0 0-.34 3.548 6.2 6.2 0 0 0 1.635 3.15l2.782 2.868c.386.397.913.624 1.468.624s1.083-.227 1.468-.624l2.782-2.868a6.2 6.2 0 0 0 1.635-3.15 6.3 6.3 0 0 0-.34-3.548 6.13 6.13 0 0 0-2.203-2.766A5.9 5.9 0 0 0 7.999 1m0 3.123a2.86 2.86 0 0 0-2.014.828 2.83 2.83 0 0 0 0 4.016 2.86 2.86 0 0 0 4.03 0 2.83 2.83 0 0 0 0-4.016A2.86 2.86 0 0 0 8 4.123m-.951 1.9a1.35 1.35 0 0 1 1.904 0 1.32 1.32 0 0 1 0 1.872 1.35 1.35 0 0 1-1.904 0 1.32 1.32 0 0 1 0-1.872",
      clipRule: "evenodd"
    })
  }));
};

export { WaypointIcon };
